import { gql } from '@apollo/client';
import { LinkFragment } from '@landsbankinn/shared/graphql/prismic/fragments/linkFragment';

export const websiteQuery = gql`
  ${LinkFragment}
  query website($lang: String = "is") {
    allWebsites(lang: $lang) {
      edges {
        node {
          _meta {
            id
            uid
            tags
            lang
            alternateLanguages {
              id
              uid
              lang
            }
            firstPublicationDate
            lastPublicationDate
          }
          title
          seo_image
          seo_description
          navigation {
            navigation_title
            navigation_item {
              ...LinkFragment
            }
          }
          quicklinks {
            quicklink_title
            quicklink_icon
            quicklink_link {
              ...LinkFragment
            }
          }
          opening_hours
          bottom_links {
            bottomlink_title
            bottomlink_link {
              ...LinkFragment
            }
          }
          cards {
            card_heading
            card_image
            card_copy
            card_link {
              ...LinkFragment
            }
          }
          text
          shortcuts {
            s_icon
            s_link {
              ...LinkFragment
            }
            s_text
            s_param
          }
          social_media {
            icon
            link_text
            link {
              ...LinkFragment
            }
          }
          bac_copy
          bac_title
          bac_background
          bac_link_text
          bac_link {
            ...LinkFragment
          }
          bac_images {
            image
          }
          body {
            ... on WebsiteBodyGroup {
              primary {
                group_title
              }
              fields {
                link {
                  ...LinkFragment
                }
                link_text
              }
            }
          }
        }
      }
    }
  }
`;
